import { useMemo } from "react";
import { LocalStorageKeys } from "@/components/pages/login/hooks/useLocalStorage";
import {
  decodeJwtPayload,
  isSuperAdminJwtPayload,
  isGuesteriaAdminJwtPayload,
  isTenantAdminJwtPayload,
} from "@/utils/authSessionUser";
import { PlatformRole } from "@/utils/accessControl";
import { Role } from "@/types/user";

export type LayoutRole =
  | typeof PlatformRole.SUPER_ADMIN
  | typeof PlatformRole.GUESTERIA_ADMIN
  | Role.TENANT_ADMIN
  | "HOTEL_SCOPED";

export const useLayoutRole = (): LayoutRole | null => {
  const token = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);

  return useMemo(() => {
    if (!token) {
      return null;
    }

    const payload = decodeJwtPayload(token);
    if (!payload) {
      return null;
    }

    if (isSuperAdminJwtPayload(payload)) {
      return PlatformRole.SUPER_ADMIN;
    }

    if (isGuesteriaAdminJwtPayload(payload)) {
      return PlatformRole.GUESTERIA_ADMIN;
    }

    if (isTenantAdminJwtPayload(payload)) {
      return Role.TENANT_ADMIN;
    }

    return "HOTEL_SCOPED";
  }, [token]);
};
